module.exports = __webpack_public_path__ + "static/FAVT_banner_tablet.15cb9513.png";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/FAVT_banner_tablet.png
// module id = 981
// module chunks = 101932004231744